import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.SAVE_LOGIN_INFO] (state, userInfo) {
    console.log(types.SAVE_LOGIN_INFO, userInfo)
    Vue.set(state, 'loginInfo', userInfo)
  },
  [types.SAVE_GOINGTOURL] (state, url) {
    Vue.set(state, 'goingToUrl', url)
  },
  [types.LOAD_LOGIN_INFO] (state) {

  }
}
